export const ORDER_DETAIL_FIELDS = Object.freeze([
  "firstName",
  "lastName",
  "email",
  "phone",
  "city",
  "state",
  "country",
  "identityType",
  "zipcode",
  "address",
  "snCode",
  "detailAddress",
  "title",
  "id",
  "orderNu",
  "ad",
]);

const hasValue = (value) =>
  value !== undefined && value !== null && value !== "";

const readFirstValue = (field, sources, fallback = "") => {
  const source = sources.find(
    (item) => item && typeof item === "object" && hasValue(item[field]),
  );

  return source ? source[field] : fallback;
};

export const createOrderDetail = (sources, overrides = {}) => {
  const normalizedSources = Array.isArray(sources) ? sources : [sources];
  const orderDetail = ORDER_DETAIL_FIELDS.reduce((result, field) => {
    result[field] = readFirstValue(field, [overrides, ...normalizedSources]);
    return result;
  }, {});

  orderDetail.snCode = readFirstValue(
    "snCode",
    [overrides, ...normalizedSources],
    readFirstValue("ssn", normalizedSources),
  );

  return orderDetail;
};
